export default __webpack_public_path__ + "static/media/black-line.3af9cfd4.svg";